var map = {
	"./hi-IN.json": [
		74804,
		4804
	],
	"./id-ID.json": [
		57047,
		7047
	],
	"./ja-JP.json": [
		90077,
		77
	],
	"./ko-KR.json": [
		55916,
		5916
	],
	"./ms-MY.json": [
		52360,
		2360
	],
	"./th-TH.json": [
		64837,
		4837
	],
	"./zh-CN.json": [
		18746,
		8746
	],
	"./zh-TW.json": [
		95261,
		5261
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 45867;
module.exports = webpackAsyncContext;